const ScrollToContacts = () => {
  const ScrollToContact = () => {
    const ContactsElement = document.querySelector('.footer') // Select the form element
    if (ContactsElement) {
      ContactsElement.scrollIntoView({ behavior: 'smooth' })
    } else {
      console.error('Form element not found.') //Added error handling
    }
  }

  return ScrollToContact //Return the function itself
}

export default ScrollToContacts